import React, { ReactNode } from "react";
import { GlobalProvider } from "../../context/global/state";
import Style from "./styles/Global";

const GlobalContainer: React.FC<{ children?: ReactNode }> = ({ children }) => {
	return (
		<GlobalProvider>
			<Style />
			{children}
		</GlobalProvider>
	);
};

export default GlobalContainer;
